import React from "react";
import { addIcon,homeIcon} from "../assets";
import { Link } from "react-router-dom";

function DashboardSidebar() {
  const linkData = [
    {
        imgSrc: homeIcon,
        path: "/dashboard",
      },
    {
      imgSrc: addIcon,
      path: "/add-tool",
    },
  ];
  return (
    <div>
      <div className="dash-nav-btn">
        {linkData.map((content) => {
          return (
            <Link to={content.path}>
              <img src={content.imgSrc} alt="dashboard icons" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default DashboardSidebar;
